import { render, staticRenderFns } from "./vue-drag-resize.html?vue&type=template&id=5a7ee868&external"
import script from "./vue-drag-resize.js?vue&type=script&lang=js&external"
export * from "./vue-drag-resize.js?vue&type=script&lang=js&external"
import style0 from "./vue-drag-resize.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.99.6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports